<template>
    <v-container v-if="checkAuthorization.backoffice">
        <h1>Admin configuration page</h1>
        <v-row>
            <v-col>
                <ConfigCard title="Clients" type="clients" />
            </v-col>
            <v-col>
                <ConfigCard title="LDAP Groups" type="ldapGroups" />
            </v-col>
        </v-row>
        <v-row>
            <v-col>
                <ConfigCard title="Headers configurations" type="headersConfigurations" />
            </v-col>
            <v-col>
                <BigDataConfigCard title="Translations" type="translations" />
            </v-col>
        </v-row>
        <v-row>
            <v-col>
                <BigDataConfigCard title="Logos" type="logos" />
            </v-col>
            <v-col>
                <ConfigCard title="HTML - Headers and Footers for clients" type="html" />
            </v-col>
        </v-row>
        <v-row>
            <v-col>
                <ConfigCard title="Emails templates" type="emailsList" />
            </v-col>
            <v-col>
                <ConfigCard title="Scopeflows" type="scopeflows" />
            </v-col>
        </v-row>
        <v-row>
            <v-col>
                <ConfigCard title="BI iFrames" type="iframesBI" />
            </v-col>
            <v-col>
                <ConfigCard title="BPM iFrames" type="iframesBPM" />
            </v-col>
        </v-row>
        <v-row>
            <v-col>
                <ConfigCard title="Generic iFrames" type="iframeGeneric" />
            </v-col>
            <v-col>
                <ConfigCard title="Track and Trace documents" type="trackTraceDocuments" />
            </v-col>
        </v-row>
        <v-row>
            <v-col>
                <ConfigCard title="Generic Search portlets" type="genericSearch" />
            </v-col>
            <v-col>
                <ConfigCard title="Track and Trace OSOL keys" type="osolKeys" />
            </v-col>
        </v-row>
        <v-row>
            <v-col>
                <ConfigCard title="Docs portlets" type="docsPortlets" />
            </v-col>
            <v-col></v-col>
        </v-row>
    </v-container>
</template>

<script>
import ConfigCard from '@/components/ConfigCard';
import BigDataConfigCard from '@/components/BigDataConfigCard';

export default {
    name: 'Home',
    components: {
        ConfigCard,
        BigDataConfigCard
    },
    computed: {
        checkAuthorization() {
            return {
                backoffice: this.$store.state.groups.authorization?.admin
            };
        }
    }
};
</script>
